import script from "./add-filter-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-filter-search.vue?vue&type=script&setup=true&lang=ts"

import "./add-filter-search.vue?vue&type=style&index=0&id=9b81493b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b81493b"]])

export default __exports__